import { render, staticRenderFns } from "./SaleHistoryEventReminderSentInfo.vue?vue&type=template&id=23a521e9&scoped=true"
import script from "./SaleHistoryEventReminderSentInfo.vue?vue&type=script&lang=ts"
export * from "./SaleHistoryEventReminderSentInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a521e9",
  null
  
)

export default component.exports